const createApiTypes = type => {
  const obj = {};
  obj.REQUEST = `${type}_REQUEST`;
  obj.SUCCESS = `${type}_SUCCESS`;
  obj.FAILURE = `${type}_FAILURE`;
  obj.TYPE = type;
  return obj;
};

export default createApiTypes;
